<template>
  <div id="userGroupViewDetails">
    <h1>{{ $t('privatePage.usergroup_header') }}</h1>
    <b-tabs>
      <b-tab :title="$t('privatePage.details')" active>
        <div class="groupTabContent">
          <user-group-detail-editor>
          </user-group-detail-editor>
        </div>
      </b-tab>
      <b-tab :title="$t('privatePage.testmethods_header')" v-if="currentGroup.id">
        <div class="groupTabContent">
          <user-group-test-method-selector :testMethods="availableTestMethods" :isSupplierCompany="isSupplierCompany" v-on:onSubmit="onSubmit">
          </user-group-test-method-selector>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserGroupDetailEditor from '../../components/users/usergroupdetaileditor'
import UserGroupTestMethodSelector from '../../components/users/usergrouptestmethodselector'

export default {
  components: {
    UserGroupDetailEditor,
    UserGroupTestMethodSelector
  },
  computed: {
    ...mapGetters('userGroupsModule', [
      'currentGroup',
      'availableTestMethods',
      'userCompany'
    ]),
    ...mapGetters(['defaultCulture', 'hasSupplierPermissions']),
    isSupplierCompany() {
      if (this.currentGroup && this.userCompany) {
        return (
          this.currentGroup.id === this.userCompany.id &&
          this.hasSupplierPermissions
        )
      } else return false
    }
  },
  created() {
    if (this.currentGroup.id) {
      this.getAvailableTestMethods(this.currentGroup.id)
    }
  },
  methods: {
    ...mapActions({
      showSuccessMessage: 'showSuccessMessage',
      showErrorMessage: 'showErrorMessage'
    }),
    ...mapActions('userGroupsModule', {
      getAvailableTestMethods: 'getAvailableTestMethods',
      updateAvailableTestMethods: 'updateAvailableTestMethods'
    }),
    onSubmit(testMethods) {
      this.updateAvailableTestMethods({
        groupId: this.currentGroup.id,
        testMethods
      })
        .then(() => {
          this.showSuccessMessage(this.$t('save_ok_feedback'))
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    }
  }
}
</script>

<style>
.groupTabContent {
  margin-top: 30px;
  margin-left: -15px;
}
</style>
